import { Box, Flex, Text, Avatar } from "@chakra-ui/react";
import { ProfileContext } from "context/ProfileContext";
import moment from "moment";
import { useContext } from "react";
import { Conversation } from "../types/Conversation.type";
import { truncateHtml } from "helpers/stringHelper";
import { FiUser } from "react-icons/fi";
import Tooltip from "components/Tooltip";

interface ConversationCardProps {
	conversation: Conversation;
	active: boolean;
	onClick: () => void;
}

/**
 * Provides the conversation display view
 * @param param0
 * @returns
 */
export const ConversationCard: React.FC<ConversationCardProps> = ({
	conversation,
	active,
	onClick,
}) => {
	// @ts-ignore
	const { isClientProfileActive } = useContext(ProfileContext);

	const updatedAt = moment(conversation.updated_at).format(
		"ddd DD MMM, YYYY h:mm A"
	);

	const trimmedMessage = truncateHtml(conversation.latest_message_body, {
		maxCharacters: 50,
		maxLines: 2,
	});

	return (
		<Flex
			p={3}
			gap={3}
			cursor="pointer"
			className={`border-b hover:bg-blue-50 ${active ? "bg-blue-200" : ""}`}
			onClick={onClick}
		>
			{isClientProfileActive && conversation.created_by_company && (
				<Tooltip label={conversation.created_by_company.name}>
					{conversation.created_by_company.logo_path ? (
						<Avatar
							src={conversation.created_by_company.logo_path}
							size="sm"
						/>
					) : (
						<FiUser size={32} />
					)}
				</Tooltip>
			)}
			<Box flex="1">
				<Flex justify="space-between">
					<Text fontWeight="semibold">
						#{conversation.reference_id} {conversation.subject}
					</Text>
					<Text
						fontSize="xs"
						color="gray.500"
					>
						{updatedAt}
					</Text>
				</Flex>
				<Text
					fontSize="sm"
					color="gray.600"
					noOfLines={2}
					dangerouslySetInnerHTML={{ __html: trimmedMessage.value }}
				></Text>
			</Box>
		</Flex>
	);
};
